// extracted by mini-css-extract-plugin
export var container = "advantages-module--container--OP9Xh";
export var icon = "advantages-module--icon--d0uzd";
export var root = "advantages-module--root--k34ub";
export var text = "advantages-module--text--V9MFs";